import { render } from "./Navigation-bar.vue?vue&type=template&id=2abe19fb&scoped=true"
const script = {}

import "./Navigation-bar.vue?vue&type=style&index=0&id=2abe19fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2abe19fb"]])

export default __exports__